import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

var init = false;
var swiper;
function swiperCard() {
  if (window.innerWidth <= 768) {
    if (!init) {
      init = true;
      swiper = new Swiper('[board-carousel]', {
        slidesPerView: 'auto',
        navigation: {
          nextEl: '.board-button-next',
          prevEl: '.board-button-prev',
        },
      });
    }
  } else if (init) {
    swiper.destroy();
    init = false;
  }
}
swiperCard();
window.addEventListener('resize', swiperCard);